<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card class="mat-elevation-z6 flex w-72 flex-col p-0">
			<div fxHide></div>
			<mat-calendar
				(selectedChange)="this.selectedChange($event)"
				[selected]="viewDate$range | async"
				class="-mt-4"
			></mat-calendar>
		</mat-card>
	</div>
</ng-template>
